export default function changeOrderAttributes(objectToChange) {
  const order = [
    'ev_ver',
    'ctm_id',
    'rq_id', // ssp
    'dl_pos',
    'rq_ts', // ssp
    'ev_st',
    'err_cod',
    'err_tp',
    'rq_tp', // => AD|CONTENT
    'format', // ssp
    'imp_tp',
    'bundle', // ssp
    'data',
    'dvc_id', // ssp
    // 'pb_endp',  // ssp
    'net_id',
    'pb_uid', // ssp
    'pb_adunit', // ssp
    'num_ads', // ssp a pelo 1
    // 'ip', // ssp
    // 'country', // ssp
    'ad_tp', // ssp
    // 'sz_id', // ssp
    'dl_vid_pos', // (pre/pos/mid/oustream)
    'plt_tp', // ssp
    'dvc_tp', // ssp
    'dvc_ua', // ssp
    'dvc_lan', // ssp
    'dvc_w', // ssp
    'dvc_h', // ssp
    'dl_tm',
    // 'net_key',
    'el_tm_glb',
    'rq_er_inf',
    'rq_er_dt',
    'dl_vst_lps',
    'dl_cid',
    'dl_win',
    'dl_vid_dur',
    // 'ip_ver',
    'sdk_tp', // ssp
    // 'sdk_med',
    'sdk_ver', // ssp
    'ad_sz_rl', // ssp
    'dvc_br', // ssp
    'dvc_mod', // ssp
    // 'dvc_pd_nm', // ssp
    'dvc_os', // ssp
    'dvc_os_ver', // ssp
    // 'dvc_cn_tp', // ssp
    // 'dvc_cn_tp_dtl', // ssp
    // 'dvc_d', // ssp
    // 'omsdk_nm', // ssp
    // 'omsdk_ver', // ssp
    // 'lat', // ssp
    // 'lon', // ssp
    // 'cch_or_id_rq',
    // 'cch_key',
    // 'cch_ad_id',
    // 'dl_cch',
    // 'byt_lon',
    'dl_crid',
    'dl_adom',
    'dl_dsp',
    'dl_vid_dis',
    // 'prc_pb_rq', // ssp
    // 'prc_pb_rs',
    // 'prc_net_rq',
    // 'prc_net_rs_g',
    // 'prc_net_rs_n',
    // 'prc_net_rs_g2',
    'ext_cli',
    // 'ext_2',
    'src',
    // 'net_ck_id',
    'rc_id',
    'rq_or',
  ];
  const obNeworder = {};

  order.forEach((item) => {
    obNeworder[item] = objectToChange[item];
    // eslint-disable-next-line no-param-reassign
    delete objectToChange[item];
  });

  const objWithAllParams = Object.assign(obNeworder, objectToChange);
  return objWithAllParams;
}
